import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SnackService } from 'src/app/services/snack.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class StockForSignControllerRequestService {
  private static BASE_URL = '/signs';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializeNumber = (res) => res as number;
  private readonly deserializeTotalInProdInOfferStockResult = (res) =>
    res as TotalInProdInOfferStockResult;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      StockForSignControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public totalStockForSign(id: number): Promise<number> {
    return this.get(`/stockForSign/${id}`, this.deserializeNumber).toPromise();
  }

  public totalStockAvailableForOrderForSign(id: number): Promise<number> {
    return this.get(
      `/stockForSignAvailableForOrder/${id}`,
      this.deserializeNumber
    ).toPromise();
  }

  public totalInProdInOfferStockForSign(
    id: number
  ): Promise<TotalInProdInOfferStockResult> {
    return this.get(
      `/total-InProd-InOffer-StockForSign/${id}`,
      this.deserializeTotalInProdInOfferStockResult
    ).toPromise();
  }
}

interface TotalInProdInOfferStockResult {
  totalStock: number;
  inProductionStock: number;
  inOfferStock: number;
}
